export default {
    'Menu': 'Menü'
};



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/core/oncanvas/translations/de.js
// module id = 95
// module chunks = 0